import {
  IError,
  ILogin,
  ISendLoginPayload,
  RESET_LOGIN,
  SEND_LOGIN,
  SEND_LOGIN_FAIL,
  SEND_LOGIN_SUCCESS,
  UPDATE_SOCIAL_TOKEN,
} from '.'
import { ActionResponse } from '../../interfaces'

export const sendLogin = (payload: ISendLoginPayload): ActionResponse<ISendLoginPayload> => ({
  type: SEND_LOGIN,
  payload,
})

export const sendLoginSuccess = (payload: ILogin): ActionResponse<ILogin> => ({
  type: SEND_LOGIN_SUCCESS,
  payload,
})

export const sendLoginFail = (payload: IError): ActionResponse<IError> => ({
  type: SEND_LOGIN_FAIL,
  payload,
})

export const updateSocialToken = (payload: string): ActionResponse<string> => ({
  type: UPDATE_SOCIAL_TOKEN,
  payload,
})

export const resetLogin = () => ({
  type: RESET_LOGIN,
})
